<template>
  <div class="countdown-container">
    <div class="countdown-display">{{ formattedTime }}</div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

// Estado reativo para o total de segundos e o ID do intervalo
const totalSeconds = ref(0);
let countdownInterval = null;

// Expondo as funções para serem acessíveis do componente pai
defineExpose({ startTimer, stopTimer });

/**
 * Propriedades/Eventos
 */
const emit = defineEmits(['time-is-up']);

/**
 * Propriedades Computadas
 */
const formattedTime = computed(() => {
  const h = Math.floor(totalSeconds.value / 3600);
  const m = Math.floor((totalSeconds.value % 3600) / 60);
  const s = totalSeconds.value % 60;

  const pad = (num) => String(num).padStart(2, '0');

  return `${pad(h)}:${pad(m)}:${pad(s)}`;
});

/**
 * Funções do Componente
 */
function startTimer(hours, minutes, seconds) {
  stopTimer(); // Limpa qualquer timer anterior
  
  if (hours < 0 || minutes < 0 || seconds < 0) {
    console.error("Os parâmetros de tempo devem ser números positivos.");
    return;
  }

  totalSeconds.value = hours * 3600 + minutes * 60 + seconds;

  countdownInterval = setInterval(() => {
    if (totalSeconds.value > 0) {
      totalSeconds.value--;
    } else {
      stopTimer();
      emit('time-is-up');
    }
  }, 1000);
}

function stopTimer() {
  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }
}
</script>

<style scoped>
.countdown-container {
  font-family: Arial, sans-serif;
  text-align: center;
  padding: 20px;
}

.countdown-display {
  font-size: 1em;
  font-weight: bold;
  color: white;
}
</style>